import { Instance, types } from 'mobx-state-tree';

export const UserLogModel = types.model({
  id: types.number,
  username: types.string,
  email: types.string,
});

export const UserActivityModel = types.model({
  id: types.number,
  action: types.string,
  createdAt: types.string,
  user: UserLogModel,
});

export type UserActivity = Instance<typeof UserActivityModel>;
